import {useEffect,useState} from 'react';
import InventoryReq from "./InventoryReq";
import PaymentRequest from "./PaymentRequest";
import PaymentRequestHistory from "./PaymentRequestHistory";
import PaymentRequestApprove from "./PaymentRequestApprove";
import Vendors from "./Vendors";
import UpdateVendor from "./UpdateVendor";
import Approve from './Approve';
import Login from "./Login";
import History from "./History";
import Notfound from "./Notfound";
import Download from "./Download";
import './App.css';
import { Route, Routes } from 'react-router-dom';
import Layout from "./Layout";
import RequireAuth from "./components/common/RequireAuth";
import AuthVerify from "./components/common/AuthVerify";
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import useAuth from "./hooks/useAuth";
import LocationSelection from "./LocationSelection";
import { AuthProvider } from "./context/AuthProvidor";
import Home from "./Home";

function App() {

  const [isInstalled, setIsInstalled] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    // Check if the app is installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
    }

    // Listen for the beforeinstallprompt event
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    });

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener('beforeinstallprompt', () => { });
    };
  }, []);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {auth, logout} = useAuth();

  const handleLogout = () =>{
    logout();
    dispatch({ type: 'resetorders', payload: {}});
    dispatch({ type: 'resetorderitems', payload: {}});
    dispatch({ type: 'resetpayments', payload: {}});
    navigate('/login');
  }

  //console.log(process.env.REACT_APP_API_KEY);
  return (
    <div className="container-fluid">
      <div className="row">
        <AuthProvider>
          <Routes>          
            <Route path="/" element={<Layout/>}>
              <Route path="login" element={<Login deferredPrompt={deferredPrompt} />} exact />
              <Route element={<RequireAuth allowedRoles={['Common','Administrator']}/>}>    
                <Route path="location" element={<LocationSelection/>} />
                <Route path="inventoryRequest" element={<InventoryReq/>} />            
                <Route path="history" element={<History/>} />
              </Route>
              <Route element={<RequireAuth allowedRoles={['Administrator']}/>}>
                {/* <Route path="user" element={<User/>} /> */}
                {/* <Route path="updateUser" element={<UpdateUser/>} /> */}
                <Route path="approve" element={<Approve/>} />
                <Route path="report" element={<Download/>} />
              </Route>
              <Route element={<RequireAuth allowedRoles={['Maker', 'Checker', 'Authorizer']}/>}>
                <Route path="vendors" element={<Vendors/>} />
                <Route path="paymentrequest" element={<PaymentRequest/>} />
                <Route path="updateVendor" element={<UpdateVendor/>} />
                <Route path="paymenthistory" element={<PaymentRequestHistory/>} />
              </Route>
              <Route element={<RequireAuth allowedRoles={['Checker', 'Authorizer']}/>}>
                <Route path="paymentapprove" element={<PaymentRequestApprove/>} />
                {/* <Route path="paymentreport" element={<PaymentDownload/>} /> */}
              </Route>
              <Route index element={<Home />} />
              <Route path="unauthorized" element={<unauthorized/>} />
              <Route path="*" element={<Notfound/>}/>
            </Route>
          </Routes>

          <AuthVerify logOut={handleLogout}/>
        </AuthProvider>
      </div>
    </div>
  );
}

export default App;
